import { api } from "./api";

/** Email-code sign-in (Better Auth email OTP endpoints). */
export async function requestCode(email: string): Promise<void> {
  await api("/auth/email-otp/send-verification-otp", {
    method: "POST",
    json: { email: email.trim().toLowerCase(), type: "sign-in" },
  });
}

export async function verifyCode(email: string, otp: string): Promise<void> {
  await api("/auth/sign-in/email-otp", {
    method: "POST",
    json: { email: email.trim().toLowerCase(), otp: otp.trim() },
  });
}

export async function signOut(): Promise<void> {
  await api("/auth/sign-out", { method: "POST", json: {} });
}
